<template>
    <div
        class="container-fluid text-left page-card admin-weflix-editPlan d-flex flex-column flex-grow-1"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div class="d-flex flex-column flex-grow-1">
            <h1 class="card-title mb-2">Editar Plano</h1>
            <p class="card-subtitle mb-4 mb-md-0">
                Escolha um nome e uma periodicidade de renovação de assinatura
                para este plano.
            </p>
            <hr class="page-card__divider mb-md-6" />
            
            <div class="row" v-if="hasReady">
                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Nome do Plano<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="nomePlano"
                            placeholder="Plano Mensal - 2º Semestre"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" for="valorPlano"
                            >Valor<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                        id="valorPlano"
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="valorPlano"
                            placeholder="R$ 99,99"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Frequência de Renovação<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <select
                            required
                            class="inputd mb-1"
                            v-model="frequenciaRenovacao"
                        >
                            <option value="" disabled selected>
                                Selecione a frequência
                            </option>
                            <option value="1">Mensal</option>
                            <option value="2">Trimestral</option>
                            <option value="3">Semestral</option>
                            <option value="4">Anual</option>
                        </select>
                        <small
                            >Escolha a frequência de renovação do plano.</small
                        >
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Definir como recomendado<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div
                        class="form-input"
                        style="display: flex; flex-wrap: wrap; gap: 10px"
                    >
                        <CustomToggle v-model="recomendado" />
                        <small
                            >Um plano recomendado é tratado como principal na
                            tela de pagamento. Ative como recomendado e o Plano
                            terá mais destaque.</small
                        >
                    </div>
                </div>

                <hr class="page-card__divider" />
                <div class="col-12 col-md-8 offset-md-2 py-3 p-md-4">
                    <div class="paymentMethods">
                        <div class="creditCard">
                            <img src="@/assets/Weflix/cartao.png" />
                            <div class="infoCreditCard">
                                <h4>Cartão de Crédito</h4>
                                <p>
                                    Seus clientes poderão pagar
                                    <strong style="color: #160266"
                                        >R${{
                                            formatarNumero(valorPlano)
                                        }}</strong
                                    >
                                    parcelados em até 3x de
                                    <strong style="color: #160266">
                                        R${{
                                            formatarNumero(valorPlano / 3)
                                        }}</strong
                                    >.
                                </p>
                            </div>
                        </div>
                        <!-- <div class="boleto">
                        <img src="@/assets/Weflix/boleto.png"/>
                        <div class="infoCreditCard">
                            <h4>Boleto</h4>
                            <p>Ative o pagamento em boleto para que seus assinantes possam adquirir o plano à vista.</p>
                        </div>
                        <div class="">
                            <span>Habilitar: </span>
                            <input data-v-2b0f9452="" data-v-508f1204="" class="form-check-input" type="checkbox" role="switch" v-model="habilitarBoleto">
                        </div>
                    </div> -->
                        <!-- <hr/>
                    <div class="boleto">
                      <img src="@/assets/Weflix/boleto.png"/>
                      <div class="infoCreditCard">
                          <h4>Pix</h4>
                          <p>Ative o pagamento em Pix para que seus assinantes possam adquirir o plano à vista.</p>
                      </div>
                      <div class="">
                          <span>Habilitar: </span>
                          <input data-v-2b0f9452="" data-v-508f1204="" class="form-check-input" type="checkbox" role="switch" v-model="habilitarPix">
                      </div>
                  </div> -->
                    </div>
                </div>
                <hr class="page-card__divider" />
            </div>
        </div>

        <div
            class="d-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-5 mt-md-7"
        >
            <v-btn
                variant="outlined"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                @click="() => this.$router.push('/admin/pagamentos')"
            >
                Voltar
            </v-btn>
            <v-btn
                variant="flat"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                @click="editPlan"
                >Salvar</v-btn
            >
        </div>
        <Loader :hasReady="hasReady" />
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import Plans from '@/utils/Weflix/plan';
    import Loader from '@/components/Weflix/Loader.vue';
    import CustomToggle from '@/components/Form/CustomToggle.vue';

    export default {
        components: {
            Loader,
            CustomToggle,
        },
        data() {
            return {
                name: '',
                imagePreviewCover: '',
                nomePlano: '',
                valorPlano: '',
                frequenciaRenovacao: '',
                recomendado: false,
                habilitarBoleto: false,
                habilitarPix: false,
                hasReady: false,
            };
        },
        computed: {
            ...mapState(['token']),
        },
        methods: {
            async editPlan() {
                const id = this.$route.params.slug;

                const payload = {
                    name: this.nomePlano,
                    planValue: parseFloat(this.valorPlano),
                    planType: this.frequenciaRenovacao,
                    recommended: this.recomendado ? 1 : 0,
                    card: 1,
                    billet: this.habilitarBoleto ? 1 : 0,
                    pix: this.habilitarPix ? 1 : 0,
                    discount: '',
                    status: 1,
                };
                try {
                    this.hasReady = false;
                    const response = await Plans.editPlan(
                        payload,
                        this.token,
                        id
                    );
                    this.$router.push('/admin/pagamentos');
                } catch (error) {
                    this.notify(
                        'Erro ao editar plano. Verifique os dados e tente novamente.',
                        'error'
                    );
                    console.error('Erro ao criar plano:', error);
                } finally {
                    this.hasReady = true;
                }
            },
            async getPlan() {
                const id = this.$route.params.slug;
                try {
                    const response = await Plans.getPlanById(this.token, id);
                    this.nomePlano = response.name;
                    this.valorPlano = response.planValue;
                    this.frequenciaRenovacao = response.planType;
                    this.recomendado = response.recommended == 1 ? true : false;
                    this.habilitarBoleto = response.billet == 1 ? true : false;
                    this.habilitarPix = response.pix == 1 ? true : false;
                    this.hasReady = true;
                } catch (error) {
                    console.error('Erro ao criar plano:', error);
                }
            },
            formatarNumero(numero) {
                let number = parseFloat(numero).toFixed(2);
                return number.replace('.', ',');
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
        created() {
            this.getPlan();
        },
    };
</script>

<style scoped>
    @import url(./global.css);
    .admin-weflix-editPlan {
        height: 100%;
        position: relative;
    }
    .creditCard {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        text-align: left;
        gap: 21px;
    }
    .boleto {
        display: flex;
        flex-wrap: wrap;
        padding: 5px 20px;
        align-items: center;
        text-align: left;
        gap: 21px;
    }
    .boleto img {
        width: 22px;
        height: 30px;
    }
    .infoCreditCard h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
    }
    .infoCreditCard {
        width: 80%;
    }

    .infoCreditCard p {
        margin: 0;
        color: gray;
    }
    .form-control:disabled {
        cursor: not-allowed;
        background-color: #f0f0f0;
    }
    @media (max-width: 600px) {
        .admin-weflix-editPlan h3 {
            font-size: 20px;
            margin-bottom: 5px;
        }
        .admin-weflix-editPlan small {
            font-size: 12px;
            color: #666;
        }
        .admin-weflix-editPlan .contetContainerNewPlan {
            padding: 0px 10px;
        }
        .admin-weflix-editPlan .actions .btn {
            width: 100%;
        }
    }
</style>
